import React from 'react'
import Contact from './About/Contact'
import Guide from './About/Guide'
import FAQ from './About/FAQ'
import Terms from './About/Terms'
import Privacy from './About/Privacy'
import Legal from './About/Legal'
import Collect from './About/Collect'
import Return from './About/Return'
import AboutLayout from '../layout/About'
import NotFound from '../pages/NotFound'
import { Routes, Route } from 'react-router-dom';
import Index from './About/Index'

const About = () =>
  <Routes>
    <Route path="/"                       element={<AboutLayout />}>
      <Route path="*"                     element={<NotFound/>} />
      <Route index                        element={<Index/>} />
      <Route path="contact"               element={<Contact/>} />
      <Route path="guide"                 element={<Guide/>} />
      <Route path="faq"                   element={<FAQ/>} />
      <Route path="terms-and-conditions"  element={<Terms/>} />
      <Route path="privacy-policy"        element={<Privacy/>} />
      <Route path="legal"                 element={<Legal/>} />
      <Route path="collect"               element={<Collect/>} />
      <Route path="return"                element={<Return/>} />
    </Route>
  </Routes>

export default About